import { render, staticRenderFns } from "./evaluate_detail.vue?vue&type=template&id=4bbb896b"
import script from "./evaluate_detail.vue?vue&type=script&lang=js"
export * from "./evaluate_detail.vue?vue&type=script&lang=js"
import style0 from "./evaluate_detail.vue?vue&type=style&index=0&id=4bbb896b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports